<mat-toolbar color="primary">
    <button mat-icon-button *ngIf="isLoggedIn" (click)="snav.toggle()">
    <mat-icon>menu</mat-icon>
  </button>

    <a href="/home">
        <img src="../../../assets/toobook-logo-branco.png" alt="Logo Toobook" />
    </a>

    <span class="toolbar-spacer"></span>

    <button mat-button *ngIf="isLoggedIn" matTooltip="Meu perfil" [routerLink]="'/seguranca/usuario/perfil'">
    <mat-icon class="mat-18">person</mat-icon>
    {{ user }} | {{ nivel }}
  </button>

    <button mat-icon-button matTooltip="Sair" (click)="logout()" *ngIf="isLoggedIn">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>

<mat-sidenav-container class="navbar-sidenav-container">
    <!-- Side nav -->
    <mat-sidenav #snav [opened]="isLoggedIn" mode="side">
        <mat-nav-list>
            <!-- Cadastros -->
            <mat-list-item (click)="toggleSubmenu('cadastros')" *ngIf="temAcessoMenu(2)">
                <div class="item-menu">
                    <mat-icon>edit_square</mat-icon>
                    <p>Cadastros</p>
                    <mat-icon *ngIf="!showSubmenu('cadastros')">navigate_before</mat-icon>
                    <mat-icon *ngIf="showSubmenu('cadastros')">expand_more</mat-icon>
                </div>
            </mat-list-item>

            <!-- escolas -->
            <div *ngIf="showSubmenu('cadastros')">
                <mat-list-item [routerLink]="'/cadastro/escola/lista-escola'" *ngIf="temAcessoMenu(3)">
                    <div class="item-submenu">
                        <mat-icon>school</mat-icon>
                        <span>Escolas</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- responsaveis
      <div *ngIf="showSubmenu('cadastros')">
        <mat-list-item>
          <div class="item-submenu">
            <mat-icon>accessibility_new </mat-icon>
            <span>Responsáveis</span>
          </div>
        </mat-list-item>
      </div> -->

            <!-- produtos -->
            <div *ngIf="showSubmenu('cadastros')">
                <mat-list-item [routerLink]="'/cadastro/produto/lista-produto'" *ngIf="temAcessoMenu(5)">
                    <div class="item-submenu">
                        <mat-icon>book_2</mat-icon>
                        <span>Produtos</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- listas -->
            <div *ngIf="showSubmenu('cadastros')">
                <mat-list-item [routerLink]="'/cadastro/produtoEscola/lista-produtoEscola'" *ngIf="temAcessoMenu(6)">
                    <div class="item-submenu">
                        <mat-icon>list</mat-icon>
                        <span>Listas</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- estabelecimento -->
            <div *ngIf="showSubmenu('cadastros')">
                <mat-list-item [routerLink]="'/cadastro/estabelecimento/lista-estabelecimento'" *ngIf="temAcessoMenu(20)">
                    <div class="item-submenu">
                        <mat-icon> apartment</mat-icon>
                        <span>Estabelecimento</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- bonus escola -->
            <div *ngIf="showSubmenu('cadastros')">
                <mat-list-item [routerLink]="'/cadastro/bonusEscola/lista-bonusEscola'" *ngIf="temAcessoMenu(25)">
                    <div class="item-submenu">
                        <mat-icon>paid</mat-icon>
                        <span>Bônus Escola</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- desconto pers. escola -->
            <div *ngIf="showSubmenu('cadastros')">
                <mat-list-item [routerLink]="'/cadastro/descontoEscola/lista-descontoEscola'" *ngIf="temAcessoMenu(26)">
                    <div class="item-submenu">
                        <mat-icon>sell</mat-icon>
                        <span>Desc. Escola</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- itens sem desconto -->
            <div *ngIf="showSubmenu('cadastros')">
                <mat-list-item [routerLink]="'/cadastro/itens-sem-desconto'" *ngIf="temAcessoMenu(37)">
                    <div class="item-submenu">
                        <mat-icon>money_off</mat-icon>
                        <span>Itens sem Desc.</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- produto grupo -->
            <div *ngIf="showSubmenu('cadastros')">
                <mat-list-item [routerLink]="'/cadastro/produtoGrupo/lista-produtoGrupo'" *ngIf="temAcessoMenu(28)">
                    <div class="item-submenu">
                        <mat-icon>groups</mat-icon>
                        <span>Produto Grupo</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- produto grupo -->
            <div *ngIf="showSubmenu('cadastros')">
              <mat-list-item [routerLink]="'/cadastro/itinerario'" *ngIf="temAcessoMenu(38)">
                  <div class="item-submenu">
                      <mat-icon>library_books</mat-icon>
                      <span>Itinerário</span>
                  </div>
              </mat-list-item>
          </div>

            <!-- Consultas -->
            <mat-list-item (click)="toggleSubmenu('consultas')" *ngIf="temAcessoMenu(7) || temAcessoMenu(24)">
                <div class="item-menu">
                    <mat-icon>search</mat-icon>
                    <p>Consultas</p>
                    <mat-icon *ngIf="!showSubmenu('consultas')">navigate_before</mat-icon>
                    <mat-icon *ngIf="showSubmenu('consultas')">expand_more</mat-icon>
                </div>
            </mat-list-item>

            <!-- pedidos -->
            <div *ngIf="showSubmenu('consultas')">
                <mat-list-item [routerLink]="'/consulta/pedido/lista-pedido'" *ngIf="temAcessoMenu(7)">
                    <div class="item-submenu">
                        <mat-icon>description</mat-icon>
                        <span>Pedidos</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- pedidos alunos-->
            <div *ngIf="showSubmenu('consultas')">
                <mat-list-item [routerLink]="'/consulta/pedido-aluno'" *ngIf="temAcessoMenu(24)">
                    <div class="item-submenu">
                        <mat-icon>school</mat-icon>
                        <span>Pedidos Alunos</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- Conciliacao -->
            <mat-list-item (click)="toggleSubmenu('conciliacao')" *ngIf="temAcessoMenu(21)">
                <div class="item-menu" [routerLink]="'/conciliacao/boleto'">
                    <mat-icon class="mat-18">
                        <fa-icon [icon]="faBarcode"></fa-icon>
                    </mat-icon>
                    <p>Conc. de Boletos</p>
                </div>
            </mat-list-item>

            <mat-list-item (click)="toggleSubmenu('conciliacao')" *ngIf="temAcessoMenu(40)">
                <div class="item-menu" [routerLink]="'/conciliacao/pix'">
                    <mat-icon class="mat-18" fontIcon="pix"></mat-icon>
                    <p>Conc. de PIX</p>
                </div>
            </mat-list-item>

            <!-- Apoio -->
            <mat-list-item (click)="toggleSubmenu('apoio')" *ngIf="temAcessoMenu(8)">
                <div class="item-menu">
                    <mat-icon>work</mat-icon>
                    <p>Apoio</p>
                    <mat-icon *ngIf="!showSubmenu('apoio')">navigate_before</mat-icon>
                    <mat-icon *ngIf="showSubmenu('apoio')">expand_more</mat-icon>
                </div>
            </mat-list-item>

            <!-- serie -->
            <div *ngIf="showSubmenu('apoio')">
                <mat-list-item [routerLink]="'/apoio/serie/lista-serie'" *ngIf="temAcessoMenu(9)">
                    <div class="item-submenu">
                        <mat-icon>diversity_3</mat-icon>
                        <span>Série</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- form pagto -->
            <div *ngIf="showSubmenu('apoio')">
                <mat-list-item [routerLink]="'/apoio/formaPagamento/lista-formaPagamento'" *ngIf="temAcessoMenu(10)">
                    <div class="item-submenu">
                        <mat-icon>payments</mat-icon>
                        <span>Forma Pagto</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- Adm Cartão -->
            <div *ngIf="showSubmenu('apoio')">
                <mat-list-item [routerLink]="'/apoio/administradora/lista-administradora'" *ngIf="temAcessoMenu(11)">
                    <div class="item-submenu">
                        <mat-icon>credit_card</mat-icon>
                        <span>Adm. Cartão</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- parametros -->
            <div *ngIf="showSubmenu('apoio')">
                <mat-list-item [routerLink]="'/apoio/parametro/lista-parametro'" *ngIf="temAcessoMenu(17)">
                    <div class="item-submenu">
                        <mat-icon>flag</mat-icon>
                        <span>Parâmetros</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- Segurança -->
            <mat-list-item (click)="toggleSubmenu('seguranca')" *ngIf="temAcessoMenu(12)">
                <div class="item-menu">
                    <mat-icon>lock</mat-icon>
                    <p>Segurança</p>
                    <mat-icon *ngIf="!showSubmenu('seguranca')">navigate_before</mat-icon>
                    <mat-icon *ngIf="showSubmenu('seguranca')">expand_more</mat-icon>
                </div>
            </mat-list-item>

            <!-- usuario -->
            <div *ngIf="showSubmenu('seguranca')">
                <mat-list-item [routerLink]="'/seguranca/usuario/lista-usuario'" *ngIf="temAcessoMenu(13)">
                    <div class="item-submenu">
                        <mat-icon>person</mat-icon>
                        <span>Usuário</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- menu -->
            <div *ngIf="showSubmenu('seguranca')">
                <mat-list-item [routerLink]="'/seguranca/menu/lista-menu'" *ngIf="temAcessoMenu(14)">
                    <div class="item-submenu">
                        <mat-icon>menu</mat-icon>
                        <span>Menu</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- nivel -->
            <div *ngIf="showSubmenu('seguranca')">
                <mat-list-item [routerLink]="'/seguranca/nivel/lista-nivel'" *ngIf="temAcessoMenu(15)">
                    <div class="item-submenu">
                        <mat-icon>schema</mat-icon>
                        <span>Nível</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- permissoes -->
            <div *ngIf="showSubmenu('seguranca')">
                <mat-list-item [routerLink]="'/seguranca/permissao'" *ngIf="temAcessoMenu(16)">
                    <div class="item-submenu">
                        <mat-icon>arrow_forward</mat-icon>
                        <span>Permissões</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- Relatório -->
            <mat-list-item (click)="toggleSubmenu('relatorio')" *ngIf="temAcessoMenu(18)">
                <div class="item-menu">
                    <mat-icon>table_charts</mat-icon>
                    <p>Relatórios</p>
                    <mat-icon *ngIf="!showSubmenu('relatorio')">navigate_before</mat-icon>
                    <mat-icon *ngIf="showSubmenu('relatorio')">expand_more</mat-icon>
                </div>
            </mat-list-item>

            <!-- rel pedidos -->
            <div *ngIf="showSubmenu('relatorio')">
                <mat-list-item [routerLink]="'/relatorio/pedido'" *ngIf="temAcessoMenu(19)">
                    <div class="item-submenu">
                        <mat-icon>analytics</mat-icon>
                        <span>Rel. Pedidos</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- rel filial -->
            <div *ngIf="showSubmenu('relatorio')">
                <mat-list-item [routerLink]="'/relatorio/pedidoFilial'" *ngIf="temAcessoMenu(22)">
                    <div class="item-submenu">
                        <mat-icon>description</mat-icon>
                        <span>Filial</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- rel alunos -->
            <div *ngIf="showSubmenu('relatorio')">
                <mat-list-item [routerLink]="'/relatorio/pedidoAluno'" *ngIf="temAcessoMenu(23)">
                    <div class="item-submenu">
                        <mat-icon>description</mat-icon>
                        <span>Alunos</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- rel pedidos item -->
            <div *ngIf="showSubmenu('relatorio')">
                <mat-list-item [routerLink]="'/relatorio/pedidoItem'" *ngIf="temAcessoMenu(27)">
                    <div class="item-submenu">
                        <mat-icon>description</mat-icon>
                        <span>Pedidos Item</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- rel lista de precos -->
            <div *ngIf="showSubmenu('relatorio')">
                <mat-list-item [routerLink]="'/relatorio/listaPreco'" *ngIf="temAcessoMenu(29)">
                    <div class="item-submenu">
                        <mat-icon>description</mat-icon>
                        <span>Lista de Preços</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- apoio serieicacao serie -->
            <div *ngIf="showSubmenu('relatorio')">
                <mat-list-item [routerLink]="'/relatorio/bonificacao'" *ngIf="temAcessoMenu(30)">
                    <div class="item-submenu">
                        <mat-icon>description</mat-icon>
                        <span>Bonif. Escola</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- relCancelamentoParcial -->
            <div *ngIf="showSubmenu('relatorio')">
                <mat-list-item [routerLink]="'/relatorio/cancelamentoParcial'" *ngIf="temAcessoMenu(35)">
                    <div class="item-submenu">
                        <mat-icon>description</mat-icon>
                        <span>Cancel. Parcial</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- relPedidoProduto -->
            <div *ngIf="showSubmenu('relatorio')">
                <mat-list-item [routerLink]="'/relatorio/pedidoProduto'" *ngIf="temAcessoMenu(36)">
                    <div class="item-submenu">
                        <mat-icon>description</mat-icon>
                        <span>Ped. Produto</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- relPedidoGrupo -->
            <div *ngIf="showSubmenu('relatorio')">
                <mat-list-item [routerLink]="'/relatorio/pedidoGrupo'" *ngIf="temAcessoMenu(39)">
                    <div class="item-submenu">
                        <mat-icon>description</mat-icon>
                        <span>Ped. Grupo</span>
                    </div>
                </mat-list-item>
            </div>

            <!-- Sair -->
            <mat-list-item (click)="logout()">
                <div class="item-menu">
                    <mat-icon>logout</mat-icon>
                    <p>Sair</p>
                    <div class="spacer"></div>
                </div>
            </mat-list-item>
        </mat-nav-list>
    </mat-sidenav>

    <!-- Main content -->
    <mat-sidenav-content class="sidenav-content">
        <div class="main">
            <router-outlet></router-outlet>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>